export const TOKEN_STORAGE_KEYS = {
  SELECTED_ROLE: 'selectedRole',
};
